export enum Language {
  German = 'de',
  English = 'en',
  Spanish = 'es',
  French = 'fr',
  Italian = 'it',
  Russian = 'ru',
  Japanese = 'jp',
  ChineseSimplified = 'zs',
  ChineseTraditional = 'zt',
  Korean = 'kr',
  Czech = 'cz',
  Portuguese = 'pt',
  Thai = 'th',
  Arabic = 'ar',
}
